import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.75 4A1.75 1.75 0 0 0 2 5.75v12.499c0 .966.784 1.75 1.75 1.75h16.497a1.75 1.75 0 0 0 1.75-1.75V5.75A1.75 1.75 0 0 0 20.247 4zM3.5 6.157V18.25c0 .138.112.25.25.25h16.497a.25.25 0 0 0 .25-.25V6.157l-7.522 5.055a1.75 1.75 0 0 1-1.952 0zM18.786 5.5H5.211l6.648 4.467a.25.25 0 0 0 .279 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }